import { OpenAPI } from '@/client';
import type { DashboardOverview } from '@/client/types.gen';

export type FeedbackWorkbenchSummary = {
  pending_count: number;
  seven_day_pending_count: number;
  items: Array<{
    bundle_id: string;
    platform: string;
    pending_count: number;
    seven_day_pending_count: number;
  }>;
};

export type DashboardWorkbenchSummary = {
  setting_feedback?: FeedbackWorkbenchSummary | null;
  reader_feedback?: FeedbackWorkbenchSummary | null;
};

const resolveAuthToken = async () => {
  if (typeof OpenAPI.TOKEN === 'function') {
    return OpenAPI.TOKEN({} as never);
  }
  return OpenAPI.TOKEN || '';
};

const requestAdminJson = async <T>(path: string): Promise<T> => {
  const token = await resolveAuthToken();
  const response = await fetch(`${OpenAPI.BASE}${path}`, {
    headers: {
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error((payload as { detail?: string }).detail || '请求失败');
  }
  return payload as T;
};

export const dashboardFacade = {
  async getOverview(days = 30): Promise<DashboardOverview> {
    return requestAdminJson<DashboardOverview>(`/api/v2/dashboard/overview?days=${days}`);
  },

  async getWorkbench(): Promise<DashboardWorkbenchSummary> {
    return requestAdminJson<DashboardWorkbenchSummary>(
      '/api/v2/dashboard/workbench',
    );
  },
};
